import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { MembersPage } from '@/features/access/members/members-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/members/')({ component: MembersRoute });

function MembersRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="members" crumbs={[{ label: t('access.members.title') }]}>
      <MembersPage tenantId={tenant} />
    </ConsoleShell>
  );
}
